import React from "react";
import {DragDropContext} from "@hello-pangea/dnd";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import {Box} from "@mui/material";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import {withTranslation} from "react-i18next";
import {showMessage, SNACKBAR_MESSAGE_SEVERITY_WARNING} from "../../hocs/snackbar-provider";
import LayoutSection from "../layout-section";

const sectionStyle = {
  height: "480px"
};

const reorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
};

const move = (source, destination, droppableSource, droppableDestination) => {
  const [removed] = source.splice(droppableSource.index, 1);
  destination.splice(droppableDestination.index, 0, removed);
};

const onDragEnd = (result, dimensions, setDimensions, lockedDimensions, t) => {
  const {source, destination} = result;

  // dropped outside the list
  if (!destination) {
    return;
  }

  const newDimensions = JSON.parse(JSON.stringify(dimensions));

  if (source.droppableId === destination.droppableId) {
    reorder(newDimensions[source.droppableId], source.index, destination.index);
  } else {
    const dimension = newDimensions[source.droppableId][source.index];
    if (lockedDimensions.includes(dimension)) {
      showMessage(t("components.tableLayout.drag.alert"), SNACKBAR_MESSAGE_SEVERITY_WARNING);
      return;
    }
    move(newDimensions[source.droppableId], newDimensions[destination.droppableId], source, destination);
  }

  setDimensions(newDimensions);
};

const TableLayout = ({t, layout, dimensionsInfo, lockedDimensions, setLayout, alertText}) => {
  const {filters, sections, rows, cols} = layout;

  const layoutLockedDimensions = lockedDimensions || [];

  return (
    <Box
      id="table-layout"
      sx={{
        width: "100%",
        height: "100%"
      }}
    >
      <DragDropContext onDragEnd={result => onDragEnd(result, layout, setLayout, layoutLockedDimensions, t)}>
        <Grid container spacing={2} style={{height: "100%"}}>
          {alertText && (
            <Grid id="table-layout__alert" size={12}>
              <Alert severity="warning">{alertText}</Alert>
            </Grid>
          )}
          <Grid size={3} sx={sectionStyle}>
            <LayoutSection
              id="filters"
              title={t("components.tableLayout.sections.filters")}
              Icon={<FilterListIcon />}
              dimensions={filters}
              dimensionsInfo={dimensionsInfo}
              lockedDimensions={layoutLockedDimensions}
            />
          </Grid>
          <Grid size={3} sx={sectionStyle}>
            <LayoutSection
              id="rows"
              title={t("components.tableLayout.sections.rows")}
              Icon={<ViewStreamIcon />}
              dimensions={rows}
              dimensionsInfo={dimensionsInfo}
              lockedDimensions={layoutLockedDimensions}
            />
          </Grid>
          <Grid size={3} sx={sectionStyle}>
            <LayoutSection
              id="cols"
              title={t("components.tableLayout.sections.columns")}
              Icon={<ViewColumnIcon />}
              dimensions={cols}
              dimensionsInfo={dimensionsInfo}
              lockedDimensions={layoutLockedDimensions}
            />
          </Grid>
          <Grid size={3} sx={sectionStyle}>
            <LayoutSection
              id="sections"
              title={t("components.tableLayout.sections.sections")}
              Icon={<ViewCompactIcon />}
              dimensions={sections}
              dimensionsInfo={dimensionsInfo}
              lockedDimensions={layoutLockedDimensions}
            />
          </Grid>
        </Grid>
      </DragDropContext>
    </Box>
  );
};

export default withTranslation()(TableLayout);
